import { ADICIONAR_PERFIL_USUARIO } from '../types'

export default function adicionarPerfilUsuario (usuario, perfil) {
  return {
    type: ADICIONAR_PERFIL_USUARIO,
    payload: {usuario, perfil}
  }
}
